import { TokenPairFeesResponse } from '@/pages/api/tokens/fees';
import { Address } from 'viem';

import { ClientNetworkError } from '@/lib/errors/client';
import { logger } from '@/lib/logger';

import { getBaseURL, isTest } from '@/utils/environment';
import { routes } from '@/utils/routes';
import { objectToQueryString } from '@/utils/string';

const STABLE_PAIR_BIPS = 2;
const STANDARD_PAIR_BIPS = 25;

/**
 * Get the fee amount for a limit order pair (in Bips)
 * @param tokenA - token address of the first token in the pair
 * @param tokenB - token address of the second token in the pair
 * @param chainId - chainId for the pair
 */
export const getLimitOrderFeeBips = async (
  tokenA: Address,
  tokenB: Address,
  chainId: number,
): Promise<number | undefined> => {
  try {
    const response = await fetch(
      `${isTest ? getBaseURL() : ''}${routes.api.TOKEN_FEE_CONFIG}${objectToQueryString({
        tokenAddressA: tokenA,
        tokenAddressB: tokenB,
        chainIdA: chainId,
        chainIdB: chainId,
      })}`,
    );

    if (!response.ok) throw new ClientNetworkError(response.statusText);

    const feeTokenData: TokenPairFeesResponse = await response.json();

    if (feeTokenData && feeTokenData.lo) {
      if (feeTokenData.isStablecoinPair) {
        return STABLE_PAIR_BIPS;
      }

      return STANDARD_PAIR_BIPS;
    }
  } catch (err: unknown) {
    logger.debug('error fetching limit order fee data', err);
    throw err;
  }

  return undefined;
};
